import { getUserFromToken } from './permissions';

export async function hasRole(roleName: string): Promise<boolean> {
  try {
    const user = await getUserFromToken();

    if (!user?.roles) {
      return false;
    }

    return user.roles.includes(roleName);
  } catch (error) {
    console.error('Error checking role:', error);
    return false;
  }
}

export async function hasAnyRole(roleNames: string[]): Promise<boolean> {
  try {
    const user = await getUserFromToken();

    if (!user?.roles) {
      return false;
    }

    return roleNames.some((roleName) => user.roles.includes(roleName));
  } catch (error) {
    console.error('Error checking roles:', error);
    return false;
  }
}

export async function hasAllRoles(roleNames: string[]): Promise<boolean> {
  try {
    const user = await getUserFromToken();

    if (!user?.roles) {
      return false;
    }

    return roleNames.every((roleName) => user.roles.includes(roleName));
  } catch (error) {
    console.error('Error checking roles:', error);
    return false;
  }
}

export async function getUserRoles(): Promise<string[]> {
  try {
    const user = await getUserFromToken();
    return user?.roles || [];
  } catch (error) {
    console.error('Error getting user roles:', error);
    return [];
  }
}

export async function hasTeamRole(roleName: string): Promise<boolean> {
  try {
    const user = await getUserFromToken();
    const firstTeam = user?.teams?.[0];

    if (!firstTeam?.team_role) {
      return false;
    }
    return firstTeam.team_role.includes(roleName);
  } catch (error) {
    console.error('Error checking team role:', error);
    return false;
  }
}

export async function getTeamLeadId(): Promise<number | undefined> {
  try {
    const user = await getUserFromToken();
    const firstTeam = user?.teams?.[0];

    return firstTeam?.team_id;
  } catch (error) {
    console.error('Error getting team lead id:', error);
    return undefined;
  }
}
